import React, { useState } from 'react';

import { GroupChipPicker } from '@lumapps/groups-picker/components/GroupChipPicker';
import { Group } from '@lumapps/groups/types';

import { LeaderboardSettingsProps } from '../../types';

export const LeaderboardSettings: React.FC<LeaderboardSettingsProps> = ({ onChange }) => {
    const [groups, setGroups] = useState<Group[]>([]);

    const handleGroupSelected = (groups: Group[]) => {
        setGroups(groups);
        onChange({ groups });
    };

    return (
        <div>
            <GroupChipPicker
                onGroupsSelected={(groups) => handleGroupSelected(groups)}
                selectedGroups={groups}
                shouldCloseOnSelect
            />
        </div>
    );
};
